import { Middleware } from "@floating-ui/core";

/**
 *  We always render popup initially with "position: fixed" style (to prevent
 *  scrollbars appearance and browser autoscroll to focused element) even if strategy is "absolute".
 *  But fixed position breaks popup coordinates calculation for "absolute" strategy, see
 *  - https://github.com/floating-ui/floating-ui/blob/67695bdb6ee50a8b91b083d2d6c913060591b986/packages/dom/src/platform.ts#L21
 *  - https://github.com/floating-ui/floating-ui/blob/67695bdb6ee50a8b91b083d2d6c913060591b986/packages/dom/src/utils/getOffsetParent.ts#L14
 *
 *  This middleware sets correct position for popup element and restart coordinates calculation.
 */
export const fixInitialPosition = (options = {}): Middleware => ({
    name: "fixInitialPosition",
    options,
    // eslint-disable-next-line @typescript-eslint/require-await
    async fn({ elements, strategy }) {
        const floating = elements.floating as HTMLElement;

        if (strategy === "absolute" && floating.style.position !== strategy) {
            floating.style.position = strategy;
            return { reset: { rects: true } };
        }

        return {};
    },
});
